import styled, { css } from "styled-components";
import { NavLink as Link } from "react-router-dom";
import { media } from "src/styles/mixins";

const NavLinkCSS = css`
  display: flex;
  align-items: center;
  margin-right: 40px;

  ${({ theme }) => css`
    ${media.down("TABLET")`
    align-self: flex-start;
    width:100%;
    padding: 15px 46px;
    border-bottom: 1px solid black;
    line-height: ${theme.fonts.lineHeights.xs};
    `}
  `}

  svg {
    margin-left: auto;

    ${media.up("LAPTOP")`
      display:none;
    `}
  }
`;

export const NavLink = styled(Link)`
  ${NavLinkCSS}
`;

export const NavButton = styled.button`
  border: 0;
  padding: 0;
  cursor: pointer;
  background: white;
  font-size: inherit;
  font-family: ${({ theme }) => theme.fonts.family};
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  ${NavLinkCSS}
`;
